import React from "react";
import { IRoutesConfig } from "../appRoutesConfig";
import { pageRoutes } from "../";
import { PERMISSIONS } from "@config/permissions";

export const panelRoutesConfig: IRoutesConfig = {
  auth: [PERMISSIONS.FLIGHT_CREW_SCHEDULING_SYSTEM],
  path: pageRoutes.PANEL,
  layout: React.lazy(() => import("./layout")),
  routes: [
    {
      auth: [PERMISSIONS.DOCUMENT_TEMPLATE_LIST],
      exact: true,
      component: React.lazy(() => import("./documents")),
      title: "Documents",
      path: pageRoutes.Documents,
    },
    {
      auth: [PERMISSIONS.COCKPIT_CREW_LIST],
      exact: true,
      component: React.lazy(() => import("./cockpits")),
      title: "Cockpits",
      path: pageRoutes.Cockpits,
    },
    {
      auth: [PERMISSIONS.CABIN_CREW_LIST],
      exact: true,
      component: React.lazy(() => import("./cabins")),
      title: "Cabins",
      path: pageRoutes.Cabins,
    },
    {
      auth: [PERMISSIONS.DOCUMENT_TEMPLATE_ASSIGN_JOB],
      exact: true,
      component: React.lazy(() => import("./assignment")),
      title: "Assignment",
      path: pageRoutes.Assignment,
    },
    {
      auth: [PERMISSIONS.CREATE_COCKPIT_CREW],
      exact: true,
      component: React.lazy(() => import("./createCrew")),
      title: "Create Cockpit",
      path: pageRoutes.Create_Cockpit,
    },
    {
      auth: [PERMISSIONS.CREATE_CABIN_CREW],
      exact: true,
      component: React.lazy(() => import("./createCrew")),
      title: "Create Cabin",
      path: pageRoutes.Create_Cabin,
    },
    {
      auth: [PERMISSIONS.EDIT_COCKPIT_CREW],
      exact: true,
      component: React.lazy(() => import("./continueCreateCrew")),
      title: "Create Cockpit",
      path: pageRoutes.Continue_Create_Cockpit + "/:crewID",
    },
    {
      auth: [PERMISSIONS.EDIT_CABIN_CREW],
      exact: true,
      component: React.lazy(() => import("./continueCreateCrew")),
      title: "Create Cabin",
      path: pageRoutes.Continue_Create_Cabin + "/:crewID",
    },
  ],
};
